import React from 'react';

// Styled components
import { LoaderContainer } from './styles';

export const Loader = () => {
  return <LoaderContainer role="progressbar" />;
};
